import * as React from "react"
import {Grid} from "@mui/material"
import {ImageSeeker} from "@ui-seeker/core";

import {imageModalData} from "@signals"
import {HierarchicalTextBlock, LinkIconBLock} from "@components";
import {useProxiedImage} from "../../../../Matchers/@hooks";


export default function productRawColumn(hideNumItems=false) {
	return [{
		name: 'productID', label: 'Product ID',
		options: { filterType: "textField", display: 'excluded' }
	}, {
		name: 'brandRaw', label: 'Brand Raw',
		options: { filterType: "textField", display: 'excluded' }
	}, {
		name: 'ean', label: 'Ean',
		options: { filterType: "textField", display: 'excluded' }
	}, {
		name: 'variantRaw', label: 'Variant Raw',
		options: { filterType: "textField", display: 'excluded' }
	}, {
		name: "productTitle", label: "Product Title",
		options: {
			filterType: 'textField',
			customBodyRowRenderLite: (value, rowData) => <Cell
				value={value}
				rowData={rowData}
			/>
		}
	}]
}

const Cell = ({ value, rowData }) => {
	const { decodedURL, imageResourceURL } = useProxiedImage(rowData.thumbnail)

	return <Grid container sx={{ maxWidth: 800 }}>
		<Grid item xs={3}>
			<ImageSeeker
				src={imageResourceURL}
				sx={{ border: '1px solid', borderColor: 'divider', width: 100, height: 'auto' }}
				onClick={() => imageModalData.value = {
					title: value,
					src: encodeURIComponent(decodedURL)
				}}
			/>
		</Grid>
		<Grid item xs={9}>
			<HierarchicalTextBlock title="Product ID: " titleValue={rowData.productID} />
			<HierarchicalTextBlock title="Product title: " titleValue={
				<LinkIconBLock url={rowData.productURL}>
					{rowData.productTitle}
				</LinkIconBLock>
			} />
			<HierarchicalTextBlock title="Brand Raw: " titleValue={rowData.brand} />
			<HierarchicalTextBlock title="EAN: " titleValue={rowData.ean} />
			<HierarchicalTextBlock title="Variant Raw: " titleValue={rowData.variantRaw} />
		</Grid>
	</Grid>
}
